import React, { useContext } from 'react';
import BaseApp from '../base_app';
import { IndexData } from '../../common/index-context';
import steps from './steps';

const Index = ({ redirectPath, texts }) => {
  const {
    setForceOpenFilterDropDown, setForceOpenButton,
    openTourModal, setForceCFTab, setForceMarkupCFTab
  } = useContext(IndexData);

  const stepsFunc = steps({
    setForceOpenFilterDropDown,
    setForceOpenButton,
    openTourModal,
    setForceCFTab,
    setForceMarkupCFTab
  });

  return (
    <BaseApp
      redirectPath={ redirectPath }
      texts={ texts }
      steps={ stepsFunc }
      tourName="swipe"
    />
  );
};


export default Index;
